<template>
  <aside class="menu">

    <search-autocomplete 
      class="mb-4"
      v-model="projectId"/>

    <p class="menu-label">
      products
    </p>

    <v-fade-transition mode="out-in">
      <div 
        v-if="loading" 
        class="is-relative">
        <v-spin-loader :value="true">
          <div class="py-6"></div>
        </v-spin-loader>
      </div>

      <article 
        v-if="!loading && products.length == 0" 
        class="message is-info is-fullwidth">
        <div class="message-body">
          There are no bom products not in orders.
        </div>
      </article>

      <ul v-if="products.length > 0" class="menu-list">
        <li 
          v-for="(product, i) in products" 
          :key="i">
          <a 
            @click="$emit('input', {
              product_master_id: product.product_master_id,
              stocking_unit_id: product.stocking_unit_id
            })"
            :class="{ 'is-active': 
              product.product_master_id == value.product_master_id && 
              product.stocking_unit_id == value.stocking_unit_id 
            }">
            <div class="help level mt-0 mb-1">
              <div>
                {{ product.qty_to_be_ordered }} 
                {{ product.product_master ? product.product_master.unit ? 
                  product.product_master.unit.unit_display_name : '' : '' }}<span 
                  v-if="product.qty_to_be_ordered > 1 && 
                    product.product_master &&
                    product.product_master.unit && 
                    product.product_master.unit.unit_display_name == 'Piece'">s</span>
              </div>
              <div>
                <span v-if="product.has_dimensions">
                  {{ lwt(product) }}
                </span>
                <span v-else>
                  {{ product.size }}
                </span>
              </div>
            </div>
            <div>
              {{ product.name }}
            </div>
          </a>
        </li>
      </ul>
    </v-fade-transition>

  </aside>
</template>

<script>
import VSpinLoader from '@/components/base/VSpinLoader'
import VFadeTransition from '@/components/transitions/VFadeTransition'
import SearchAutocomplete from '@/components/projects/SearchAutocomplete'

export default {
  props: {
    value: {
      type: Object
    }
  },
  components: { VSpinLoader, VFadeTransition, SearchAutocomplete },
  data() {
    return {
      loading: false,
      products: [],
      projectId: null
    }       
  },
  watch: {
    projectId() {
      this.getProductSummary();
    }
  },
  created() {
    this.getProductSummary();
  },
  methods: {
    getProductSummary() {
      this.loading = true;

      this.$http.orders.getByProduct({ 
        unordered_only: true,
        project_id: this.projectId 
      }).then(resp => {
        this.products = resp.data;
        this.loading = false;
        if (this.products.length > 0) {
          this.$emit('input', {
            product_master_id: this.products[0].product_master_id,
            stocking_unit_id: this.products[0].stocking_unit_id
          });
        }
      }).catch(() => this.loading = false);
    },
    lwt(v) {
      return `L${v.length_in_str}" x W${v.width_in_str}" x T${v.thick_in_str}"`
    }
  }
}
</script>

<style scoped>
</style>